import React, { useState, useEffect } from 'react';
import { X, Smartphone, Download } from 'lucide-react';
import {
  shouldShowMobileRedirect,
  dismissMobileBanner,
  getAppStoreUrl,
  getPlatform,
  openMobileApp,
} from '../utils/mobileDetection';

/**
 * MobileAppBanner - Shows a banner at the top/bottom of the page
 * prompting mobile users to download or open the mobile app
 */
const MobileAppBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [platform, setPlatform] = useState('desktop');

  useEffect(() => {
    // Check if we should show the banner
    if (shouldShowMobileRedirect()) {
      setIsVisible(true);
      setPlatform(getPlatform());
    }
  }, []);

  const handleDismiss = () => {
    dismissMobileBanner();
    setIsVisible(false);
  };

  const handleOpenApp = () => {
    const currentPath = window.location.pathname;
    openMobileApp(currentPath);
    // Don't dismiss the banner - user might come back
  };

  const handleGoToStore = () => {
    const appStoreUrl = getAppStoreUrl();
    if (appStoreUrl) {
      window.location.href = appStoreUrl;
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-orange-500 to-orange-600 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left side - Icon and text */}
          <div className="flex items-center space-x-3 flex-1">
            <div className="flex-shrink-0">
              <Smartphone className="h-8 w-8 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white font-semibold text-sm">
                Get the Lodgeic Mobile App
              </p>
              <p className="text-orange-100 text-xs">
                Better experience on {platform === 'ios' ? 'iOS' : 'Android'}
              </p>
            </div>
          </div>

          {/* Right side - Actions */}
          <div className="flex items-center space-x-2 ml-4">
            <button
              onClick={handleOpenApp}
              className="px-3 py-2 bg-white text-orange-600 rounded-lg font-medium text-sm hover:bg-orange-50 transition-colors flex items-center space-x-1"
            >
              <span>Open App</span>
            </button>
            <button
              onClick={handleGoToStore}
              className="px-3 py-2 bg-orange-700 text-white rounded-lg font-medium text-sm hover:bg-orange-800 transition-colors flex items-center space-x-1"
            >
              <Download className="h-4 w-4" />
              <span>Download</span>
            </button>
            <button
              onClick={handleDismiss}
              className="p-2 text-white hover:bg-orange-600 rounded-lg transition-colors"
              aria-label="Dismiss banner"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner;
